import { createFileRoute } from "@tanstack/react-router";

import { ConnectionLayout } from "~/pages/connection-new/connection.layout";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/new/_connection",
)({
  component: ConnectionLayout,
});
